import { Menu } from "antd";
import ProductDropdown from "../Performance Dashboard/productsDropdown";

interface IWorkItemConfigSideTabs {
   selectedTabKey :string,
   handleChangeTabs: (key: string) => void
}

const WorkItemConfigSideTabs = (props:IWorkItemConfigSideTabs)=>{
    const menuCSS: React.CSSProperties = { borderRight: 0, background: '#F8F8F8' };
    const {selectedTabKey,handleChangeTabs} =props
    const menuItems = [
        {
            key:0,
            label:"Work Item State Categories"
        },     
        {
            key:1,
            label:"Work Item States"
        }     
    ]
    return(
           <div className="team-config-filters">
            <div className='mb-2 border-bottom-grey p-[15px]'>
                <ProductDropdown />
            </div>
            <div className="sider-wrapper">
                <Menu
                    mode="inline"
                    theme="light"
                    selectedKeys={[`${selectedTabKey}`]}
                    style={{ ...menuCSS, height: "100%" }}
                    items={menuItems}
                    onClick={({ key }) => {
                        handleChangeTabs(key);
                    }}
                />
            </div>
  
        </div>
    )
}

export default WorkItemConfigSideTabs